import React, { useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import ButtonComponent from './buttonComponent';

export default function BoxButtonComponent({
    children,
    justify = 'flex-end',       // Default tombol ke kanan
    mt = 2,                     // Margin top default
    direction = 'row',          // row / column
    gap = 1,
    ...restProps               // Biar bisa ditambahin props lain kalau perlu
  }) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: justify,
          flexDirection: direction,
          marginTop: mt,
          gap: gap,
          flexWrap: 'wrap',     // biar responsif kalau tombol banyak
        }}
        {...restProps}
      >
        {children}
      </Box>
    );
  }